// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    MY_ACCOUNT_FORM,
    CHANGE_PASSWORD_FORM,
    PURCHASE_HISTORY_FORM,
} from '../../../constants/forms';
import i18n from '../../../i18n/i18n.js';

type Props = {
    auth: Object,
    asset: Object,
    logout: Function,
    setForm: Function,
    openModal: Function,
    language: String,
};

type State = {
    visible: boolean,
};

export default class UserMenu extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            visible: false,
            account: false,
            purchase: false,
            password: false,
            name: '',
        };
    }

    handleClick = (e: Object) => {
        e.preventDefault();
        this.setState({ visible: !this.state.visible });
    };

    handleLogout = () => {
        this.props.logout();
    };

    setForm = form => {
        this.setState({ visible: false }, () => {
            this.props.openModal();
            this.props.setForm(form);
        });
    };

    toggleHover = name => {
        this.setState({
            [name]: !this.state[name],
            name: name,
        });
    };

    render() {
        const { user } = this.props.auth;
        let lng = this.props.auth.language;

        // Branding
        let background = {
            account: '#fff',
            purchase: '#fff',
            password: '#fff',
        };

        if (this.state[this.state.name]) {
            background[this.state.name] = this.props.branding
                .paywall_primary_color
                ? this.props.branding.paywall_primary_color
                : '#00aae6';
        }

        return (
            <div id="inplayer-menu-content" className="inplayer-always-visible">
                <div
                    className="inplayer-user inplayer-toggle-menu"
                    onClick={this.handleClick}
                >
                    <i className="inplayer-avatar-toggle inplayer-avatar-box-shadow" />
                    <i className="inplayer-avatar" />
                    <div className="inplayer-username">
                        <p className="inplayer-email">{user.email}</p>
                    </div>
                </div>
                <div
                    className={
                        'inplayer-menu ' +
                        (this.state.visible ? 'show' : 'hide')
                    }
                >
                    <ul>
                        <li>
                            <a
                                className="inplayer-myaccount-btn"
                                onClick={e => {
                                    e.preventDefault();
                                    this.setForm(MY_ACCOUNT_FORM);
                                }}
                                onMouseOver={e => {
                                    e.preventDefault();
                                    this.toggleHover('account');
                                }}
                                onMouseOut={e => {
                                    e.preventDefault();
                                    this.toggleHover('account');
                                }}
                                style={{ background: background['account'] }}
                            >
                                <span data-text="user_menu_account_details">
                                    {i18n.t('user_menu_my_account', { lng })}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                className="inplayer-myaccount-btn"
                                onClick={e => {
                                    e.preventDefault();
                                    this.setForm(PURCHASE_HISTORY_FORM);
                                }}
                                onMouseOver={e => {
                                    e.preventDefault();
                                    this.toggleHover('purchase');
                                }}
                                onMouseOut={e => {
                                    e.preventDefault();
                                    this.toggleHover('purchase');
                                }}
                                style={{
                                    background: background['purchase'],
                                }}
                            >
                                <span data-text="user_menu_my_account">
                                    {i18n.t('purchases_link', { lng })}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                className="inplayer-myaccount-btn"
                                onClick={e => {
                                    e.preventDefault();
                                    this.setForm(CHANGE_PASSWORD_FORM);
                                }}
                                onMouseOver={e => {
                                    e.preventDefault();
                                    this.toggleHover('password');
                                }}
                                onMouseOut={e => {
                                    e.preventDefault();
                                    this.toggleHover('password');
                                }}
                                style={{ background: background['password'] }}
                            >
                                <span data-text="user_menu_change_password">
                                    {i18n.t('change_pass', { lng })}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a
                                className="inplayer-logout-btn"
                                href="#logout"
                                data-text="user_menu_log_out"
                                onClick={e => {
                                    e.preventDefault();
                                    this.handleLogout();
                                }}
                            >
                                {i18n.t('logout', { lng })}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/UserMenu/index.js